<template>
  <div>
    <c-row>
      <c-col col="8">
        <c-card>
          <loader v-show="loading" />
          <c-card-body v-bind:class="{ 'has-error': errors.items }">
            <div class="form-group form-row">
              <div class="col-md-3">
                <input
                  type="text"
                  ref="code"
                  class="form-control"
                  placeholder="ketikan terus enter"
                  @keyup="searchItem"
                  v-model="code"
                />
              </div>
              <div class="col-md-7">
                <span
                  class="form-control"
                  v-if="item"
                  style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  >{{ item.name }}</span
                >
                <span class="form-control" v-if="!item"></span>
              </div>
              <div class="col-md-1">
                <input
                  type="number"
                  ref="qty0"
                  class="form-control qty"
                  min="1"
                  max="999"
                  @keyup="qtyEnter"
                  v-model="qty"
                />
              </div>
              <div class="col-md-1">
                <button class="btn btn-success" @click="addItem">
                  <i class="cil-plus"></i>
                </button>
              </div>
            </div>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th width="30px">No</th>
                  <th width="100px">Code</th>
                  <th>Nama</th>
                  <th width="70px">Qty</th>
                  <th width="30px">Act</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in po.items" :key="k">
                  <td>{{ k + 1 }}</td>
                  <td class="unicode">{{ d.item.code }}</td>
                  <td>{{ d.item.name }}</td>
                  <td class="unicode right">
                    <span
                      class="form-control qty"
                      style="padding: 0.375rem"
                      @click="qtyEdit = true"
                      v-show="!qtyEdit"
                      >{{ d.qty }}</span
                    >
                    <input
                      type="number"
                      maxlength="3"
                      v-model="d.qty"
                      class="form-control qty"
                      v-show="qtyEdit"
                      @blur="setQty"
                      @keyup="setQtyKeyUp"
                    />
                  </td>
                  <td>
                    <button
                      class="btn btn-danger btn-action"
                      @click="removeItem(k, d)"
                    >
                      <i class="cil-x"></i>
                    </button>
                  </td>
                </tr>
                <tr class="tr-input">
                  <td colspan="3">
                    <select-x
                      url="/api/v1/search/product"
                      placeholder="cari berdasarkan kata kunci"
                      :size="10"
                      label="name"
                      v-model="item"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      ref="qty1"
                      class="form-control qty"
                      min="1"
                      max="999"
                      v-model="qty"
                      @keyup="qtyEnter"
                    />
                  </td>
                  <td>
                    <button class="btn btn-success" @click="addItem">
                      <i class="cil-plus"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col col="4">
        <c-card>
          <loader v-show="loading" />
          <c-card-body style="overflow: auto">
            <c-form>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">ID</span>
                  </div>
                  <span class="form-control">{{ po.faktur }}</span>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="cil-calendar"></i>
                    </span>
                  </div>
                  <span class="form-control">{{
                    po.created_at | formatDate
                  }}</span>
                </div>
              </div>
              <div class="form-group">
                <label>Supplier</label>
                <select-x
                  url="/api/v1/supplier"
                  size="5"
                  placeholder="Silahkan ketikkan keyword"
                  label="name"
                  v-bind:class="{ 'has-error': errors.supplier }"
                  v-model="po.supplier"
                  @input="changeSupplier"
                />
              </div>
              <div class="form-group">
                <label>Note</label>
                <textarea
                  id
                  cols="30"
                  rows="3"
                  v-model="po.note"
                  class="form-control"
                  placeholder="Add note"
                  v-bind:class="{ 'has-error': errors.note }"
                ></textarea>
              </div>
            </c-form>
          </c-card-body>
          <c-card-footer>
            <sur-button
              :object="po"
              @onSave="save"
              @onUpdate="update"
              @onReset="reset"
            ></sur-button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <CModal
      title="Delete Confirmation"
      size="sm"
      color="danger"
      :show.sync="removeConfirm"
    >
      Yakin Akan menghapus data
      <br />" <span v-if="itemRemove">{{ itemRemove.name }}</span
      >" ?
      <template #footer>
        <CButton @click="removeConfirm = false" color="danger">Batal</CButton>
        <CButton @click="runDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import SelectX from "../../components/SelectX";
import SURButton from "../../components/SURButton";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  name: "PoIndex",
  components: {
    SelectX,
    "sur-button": SURButton,
    Loader
  },
  data () {
    return {
      removeConfirm: false,
      item: null,
      qty: 1,
      qtyEdit: false,
      code: "",
      itemIndex: null,
      itemRemove: null,
      po: {},
      errors: [],
      loading: false
    };
  },
  created () {
    this.getCookie();
  },
  methods: {
    setQty () {
      this.setCookie();
      this.qtyEdit = false;
    },
    setQtyKeyUp (e) {
      if (e.keyCode == 13 || e.keyCode == 9) {
        this.setQty();
      }
    },
    qtyEnter (e) {
      if (e.keyCode == 13) {
        this.addItem();
      }
    },
    addItem () {
      if (!this.item) {
        this.$toasted
          .error("Silahkan scan atau cari produk terlebih dahulu")
          .goAway(3000);
        this.$refs.code.focus();
        return;
      }
      if (this.qty < 1) {
        this.$toasted.error("Masukkan qty minimal 1").goAway(3000);
        return;
      }
      var double = false;
      for (var i in this.po.items) {
        if (this.item.code === this.po.items[i].code) {
          this.po.items[i].qty += parseInt(this.qty);
          double = true;
          break;
        }
      }
      if (!double) {
        this.po.items.push({
          item: this.item,
          code: this.item.code,
          qty: parseInt(this.qty)
        });
      }
      this.setCookie();
      this.item = null;
      this.qty = 1;
      this.code = "";
    },
    removeItem (index, removeItem) {
      this.itemIndex = index;
      this.removeConfirm = true;
      this.itemRemove = removeItem;
    },
    runDelete () {
      const item = this.po.items[this.itemIndex];
      this.po.items.splice(this.itemIndex, 1);
      this.setCookie();
      this.$toasted.show(`Item "${item.name}" telah dihapus`).goAway(1000);
      this.removeConfirm = false;
    },
    searchItem (e) {
      if (e.keyCode === 13) {
        HTTPAUTH.get("/api/v1/product/code/" + this.code)
          .then(res => {
            this.item = res.data.data;
            this.$refs.qty0.focus();
          })
          .catch(eres => {
            this.$toasted.error(eres.response.data.user_message).goAway(2000);
          });
      }
    },
    setCookie () {
      this.$cookie.set("larapos.po", JSON.stringify(this.po));
    },
    cleadCookie () {
      this.$cookie.delete("larapos.po");
    },
    getCookie () {
      const query = this.$route.query;
      this.loading = true;
      if (query && query.id) {
        HTTPAUTH.get(`/api/v1/po/${query.id}/detail`).then(res => {
          const data = res.data.data;
          if (data.status === 2) {
            this.$toasted.error("Data tidak bisa diedit, PO sudah selesai").goAway(3000);
            this.$router.push({ path: '/po/process' })
          }
          data.items = data.purchase_details;
          delete data.purchase_details;
          this.loading = false;
          this.po = data;
          return
        })
      }
      this.po = JSON.parse(this.$cookie.get("larapos.po"));
      if (!this.po) {
        this.po = {
          created_at: moment().format("DD-MMM-YYYY"),
          faktur: "INV" + moment().unix(),
          items: []
        };
      }
      this.loading = false;
    },
    save () {
      HTTPAUTH.post("/api/v1/po", this.po)
        .then(() => {
          this.$toasted.success("data berhasil disimpan").goAway(2000);
          this.reset();
        })
        .catch(eres => {
          if (eres.response.data.message) {
            this.errors = eres.response.data.errors;
            this.$toasted.error(eres.response.data.message).goAway(2000);
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    changeSupplier (s) {
      this.po.supplier = s;
      this.setCookie();
    },
    update () {
      HTTPAUTH.put("/api/v1/po/" + this.po.id, this.po)
        .then(() => {
          this.$toasted.success("data berhasil disimpan").goAway(2000);
          this.reset();
          this.$router.push({ path: '/po/process' })
        })
        .catch(eres => {
          if (eres.response.data.message) {
            this.errors = eres.response.data.errors;
            this.$toasted.error(eres.response.data.message).goAway(2000);
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    reset () {
      this.supplier = {};
      this.po = {
        created_at: moment().format("DD-MMM-YYYY"),
        faktur: "INV" + moment().unix(),
        items: []
      };
      this.cleadCookie();
    }
  },
  filters: {
    formatDate (d) {
      return moment(d).format("DD MMM YYYY");
    }
  }
};
</script>